import { SyntheticEvent, useCallback } from "react";

type Props = {
  onClick: (e: SyntheticEvent) => void;
};

const useManageToolItem = ({ onClick }: Props) => {
  const windowWidth = window.innerWidth;

  const handleClick = useCallback(
    (e: SyntheticEvent) => {
      onClick && onClick(e);
    },
    [onClick]
  );

  return { handleClick, windowWidth };
};

export default useManageToolItem;
